import { AbstractDimension, type WakamApiProblem } from '@orus.eu/dimensions'
import { isFailure, type Result } from '@orus.eu/result'

export const wakamAddressValidationOutput = [
  'has-risk',
  'has-no-risk',
  /**
   * A flood risk cannot be computed because we don't have enough data in the address
   * (example invalid address)
   */
  'not-applicable',
] as const

/**
 * The result of a flood risk test from the Wakam API
 */
export type WakamAddressValidationOutput = (typeof wakamAddressValidationOutput)[number]

export type WakamAddressValidationResult = Result<WakamAddressValidationOutput, WakamApiProblem>

export class MrpwAddressValidationResultDimension<NAME extends string> extends AbstractDimension<
  NAME,
  WakamAddressValidationResult
> {
  override formatToString(value: WakamAddressValidationResult): string | undefined {
    if (isFailure(value)) {
      return value.problem.type
    }

    return value.output
  }
}
